// extracted by mini-css-extract-plugin
module.exports = {"center":"ResetPassword_center__4Wnyn","explainer":"ResetPassword_explainer__ngX9l"};